import { getView, requireAuth } from 'Lib/utils';
import { Left } from 'Models/Menu/menus';
import {
  OrganizationDetailsPage,
  OrganizationFilesPage,
  OrganizationEditPage,
} from '@/data/appInformationItems';


export default {
  path: '/organizations/:_key',
  name: 'organization',
  component: getView('pages/PageOrganization'),
  redirect: { name: 'organization-details' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'organization-details',
      component: getView('organizations/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Organizations > Details',
        leftMenu: Left.OrganizationDetails,
        information: OrganizationDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'data',
      name: 'organization-data',
      component: getView('organizations/TabData'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Organizations > Data',
        leftMenu: Left.OrganizationDetails,
        information: OrganizationDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'organization-files',
      component: getView('organizations/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Organizations > Files',
        leftMenu: Left.OrganizationFiles,
        information: OrganizationFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'members',
      name: 'organization-members',
      component: getView('organizations/TabMembers'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Organizations > Members',
        leftMenu: Left.OrganizationDetails,
        information: OrganizationFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'organizationEdit',
      component: getView('pages/PageOrganizationEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Organizations > Edit',
        leftMenu: Left.OrganizationsList,
        information: OrganizationEditPage,
        showBottomMenu: true,
      },
    },
  ],
};
